// @flow
import type {
  StoreProductOptionGroup,
  StoreProductOption,
} from '../../../entities/product-option';
import type {
  ProductOptionGroup,
  ProductOptionGroupOptionConfig,
  ProductOptionGroupOption,
  StoreProductOptionType,
  ProductOptionGroupConfig,
} from '../../../entities/product';

const mapStoreProductOptionToProductOptionGroupOption = (
  storeOption: StoreProductOption
): ProductOptionGroupOption => {
  return {
    color: storeOption.color,
    enabled: storeOption.enabled,
    id: storeOption.id,
    imageId: storeOption.imageId,
    name: storeOption.name,
    number: storeOption.number,
    price: storeOption.price?.toString() || '0',
    type: 'store-product-option',
  };
};

const mapStoreProductOptionToOptionConfig = (
  storeOption: StoreProductOption,
  index: number
): ProductOptionGroupOptionConfig => {
  return {
    type: 'product-option',
    useDefault: true,
    id: storeOption.id,
    number: storeOption.number || index,
    price: storeOption.price?.toString() || '0',
    enabled: storeOption.enabled,
    storeProductOption: mapStoreProductOptionToProductOptionGroupOption(
      storeOption
    ),
  };
};

export const mapStoreProductOptionGroupToProductOptionGroup = (
  storeProductOptionGroup: StoreProductOptionGroup,
  options: {
    fieldType?: StoreProductOptionType,
    required?: boolean,
    number?: number,
    config?: ProductOptionGroupConfig,
    isNew?: boolean,
  } = {}
): ProductOptionGroup => {
  const mappedOptions: ProductOptionGroupOptionConfig[] = storeProductOptionGroup.options.map(
    (storeOption, index) =>
      mapStoreProductOptionToOptionConfig(storeOption, index)
  );

  return {
    enabled: storeProductOptionGroup.enabled,
    config: options.config,
    id: storeProductOptionGroup.id,
    options: mappedOptions,
    storeProductOptionGroup: storeProductOptionGroup,
    required: options.required || false,
    number: options.number || 0,
    fieldType: options.fieldType || 'MULTI_OPTION',
    isNew: options.isNew || false,
  };
};
